"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHast = void 0;
const toHast = (node) => {
    if (typeof node === 'string')
        return { type: 'text', value: node };
    const [tag, properties, ...children] = node;
    const element = {
        type: 'element',
        tagName: tag + '',
        children: children.map(exports.toHast),
    };
    if (properties)
        element.properties = properties;
    return element;
};
exports.toHast = toHast;
